<template>
<v-sheet color="transparent" class="d-flex v-sheet pt-md-9 mt-md-9 ml-md-12 mt-4 ml-4">
    <v-btn fab class="d-inline-flex mr-2" :class="trackingStatus && 'green'" @click="toggleTracking()" >
        <span>
            <v-icon>mdi-crosshairs-gps</v-icon><br>
            {{GPSAccuracy}}
        </span>
    </v-btn>
    <gmap-autocomplete
        @place_changed="setPosition"
        :options="{
            bounds: {north: 49.03, south: 46.37, east: 17.16, west: 9.52},
            strictBounds: true,
            componentRestrictions: {
                country: ['at']
            },
            fields: ['geometry', 'formatted_address', 'address_components']
          }">
    <template v-slot:input="slotProps">
        <v-text-field outlined
                      prepend-inner-icon="mdi-map-marker"
                      placeholder="Adresssuche"
                      ref="input"
                      background-color="white"
                      v-on:listeners="slotProps.listeners"
        class="d-inline-flex">
        </v-text-field>
    </template>
    </gmap-autocomplete>
</v-sheet>
</template>

<script>
    export default {
        name: 'MapSearch',
        methods: {
            toggleTracking(){
                this.$store.dispatch('toggleTracking');
                if(this.trackingStatus) {
                    // just to get the actual position
                    this.$store.dispatch('getUserPosition')
                }
            },
            setPosition(place){
                if (!place || !place.geometry || !place.geometry.location) {
                    console.warn("Location could not be determined!")
                    return
                }

                if(this.trackingStatus) {
                    this.$store.dispatch('toggleTracking')
                }

                this.$store.dispatch('updateUserPosition', {
                    latitude: place.geometry.location.lat(),
                    longitude: place.geometry.location.lng()
                })

                this.$store.dispatch('updateLocation', {
                    latitude: place.geometry.location.lat(),
                    longitude: place.geometry.location.lng()
                })
            }
        },
        computed: {
            GPSAccuracy(){
                if(this.$store.state.geolocation.userPosition === null || this.$store.state.geolocation.userPosition.accuracy === null )
                    return "-";
                return Math.round(this.$store.state.geolocation.userPosition.accuracy);
            },
            trackingStatus(){
                return this.$store.getters.getTrackingStatus;
            }
        }
    }
</script>

<style scoped>
    .v-sheet{
        position: absolute;
        //margin-top:100px;
        top:0px;
        left:0px;
    }
</style>
